export default function useHuggy() {
  function loadScript() {
    if (document.getElementById('huggy-snippet')) return

    window.pwz = {
      context: {
        id: import.meta.env.VITE_HUGGY_CONTEXT_ID,
      },
    }

    const script = document.createElement('script')
    script.type = 'text/javascript'
    script.async = true
    script.id = 'huggy-snippet'
    script.src = 'https://js.huggy.chat/widget.min.js?v=8.0.0'

    const first = document.getElementsByTagName('script')[0]
    first.parentNode.insertBefore(script, first)

    script.onload = () => {
      initHuggy()
    }
  }

  function initHuggy() {
    if (window.Huggy && window.Huggy.init) {
      const huggyConfig = {
        defaultCountry: '+55',
        uuid: import.meta.env.VITE_HUGGY_UUID,
        company: import.meta.env.VITE_HUGGY_COMPANY,
      }
      window.Huggy.init(huggyConfig)
      waitForHuggy()
    }
  }

  function isChatOpen() {
    const iframe = document.querySelector('.powerzap_chat_canvas.opened')
    return !!iframe
  }

  function waitForHuggy() {
    if (window.Huggy && typeof window.Huggy.hideButton === 'function') {
      window.Huggy.hideButton()
      window.Huggy.hideChats()
      window.Huggy.closeBox()
    } else {
      setTimeout(waitForHuggy, 100)
    }
  }

  function openChat() {
    setTimeout(() => {
      window.Huggy.openBox()
    }, 100)
  }

  function closeChat() {
    setTimeout(() => {
      window.Huggy.hideChats()
      window.Huggy.closeBox()
      window.Huggy.hideButton()
    }, 100)
  }

  function toogleChat() {
    isChatOpen() ? closeChat() : openChat()
  }

  return {
    loadScript,
    openChat,
    closeChat,
    toogleChat,
  }
}
